export const Wrapper = ({ children }) => {
  return <div className="w-11/12 lg:w-4/5 sm:w-5/6 mx-auto">{children}</div>;
};
